import React from 'react'

import HightChart from '.'
import useRedux from '../../hooks/useRedux'
import { isEqual } from '../../utils/javascript'

const SankeyCharts = () => {
  const { selector } = useRedux()
  const activeTab = selector(state => state?.inventory?.activeTab)
  const { materialType } = { ...activeTab }

  const formateView = ({ name, id, virgin, pcr, className }) => {
    return `<div class=${className}>
        <h3>${name}</h3>
        <p>[${id}]</p>
         ${virgin ? `<p>Virgin : ${virgin}</p>` : ''}
        ${pcr ? `<p>Post Consumer recycled : ${pcr}</p>` : ''}
      </div>`
  }
  const otherMaterialNode = [
    {
      id: 'Scrap Vehicle 10034',
      dataLabels: {
        format: `${formateView({
          name: 'Scrap Vehicle',
          id: '10034',
        })}`,
        useHTML: true,
        x: 50,
        y: 1,
      },
    },
    {
      id: 'Scrap Vehicle 10101',
      dataLabels: {
        format: `${formateView({
          name: 'Scrap Vehicle',
          id: '10101',
        })}`,
        useHTML: true,
        x: 50,
        y: 1,
      },
    },
    {
      id: 'Scrap Vehicle 10108',
      dataLabels: {
        format: `${formateView({
          name: 'Scrap Vehicle',
          id: '10108',
        })}`,
        useHTML: true,
        x: 50,
        y: 1,
      },
    },
    {
      id: 'Recycle Job 29891',
      dataLabels: {
        format: `${formateView({
          name: 'Recycle Job',
          id: '29891',
        })}`,
        useHTML: true,
        x: 50,
        y: 1,
      },
    },
    {
      id: 'Recycle Job 29892',
      dataLabels: {
        format: `${formateView({
          name: 'Recycle Job',
          id: '29892',
        })}`,
        useHTML: true,
        x: 50,
        y: 1,
      },
    },
    {
      id: 'Recycle Job 29890',
      column: 1,
      offset: 83,
      dataLabels: {
        format: `${formateView({
          name: 'Recycle Job',
          id: '29890',
        })}`,
        useHTML: true,
        x: 50,
        y: 1,
      },
    },
    {
      id: 'Heat 31098',
      dataLabels: {
        format: `${formateView({
          name: 'Heat',
          id: '31098',
          virgin: 40,
          pcr: 60,
        })}`,
        useHTML: true,
        x: 80,
        y: -8,
      },
    },
    {
      id: 'Heat 31099',
      dataLabels: {
        format: `${formateView({
          name: 'Heat',
          id: '31099',
          virgin: 40,
          pcr: 60,
        })}`,
        useHTML: true,
        x: 80,
        y: -8,
      },
    },

    {
      id: 'Body:Part 40989',
      dataLabels: {
        format: `${formateView({
          name: 'Body:Part',
          id: '40989',
          virgin: 40,
          pcr: 60,
        })}`,
        useHTML: true,
        x: 78,
        y: 1,
      },
    },
    {
      id: 'Engine:Part 40990',
      dataLabels: {
        format: `${formateView({
          name: 'Engine:Part',
          id: '40990',
        })}`,
        useHTML: true,
        x: 50,
        y: 1,
      },
    },
    {
      id: 'Chassis:Part 40991',
      dataLabels: {
        format: `${formateView({
          name: 'Chassis:Part',
          id: '40991',
        })}`,
        useHTML: true,
        x: 50,
        y: 1,
      },
    },
    {
      id: 'Transmission:Part 40992',
      dataLabels: {
        format: `${formateView({
          name: 'Transmission:Part',
          id: '40992',
        })}`,
        useHTML: true,
        x: 68,
        y: 1,
      },
    },
    {
      id: 'Bumper:Part 40993',
      dataLabels: {
        format: `${formateView({
          name: 'Bumper:Part',
          id: '40993',
        })}`,
        useHTML: true,
        x: 50,
        y: 1,
      },
      column: 3,
    },
    {
      id: 'Steel 59089',
      dataLabels: {
        format: `<div class="text-end">
  <h3>${'Steel'}</h3>
  <p>Vehical Id : [59089]</p>
  <p>Virgin : 40</p>
  <p>Post Consumer recycled : 60</p>
</div>
        `,
        useHTML: true,
        x: 0,
        y: 1,
      },
    },
    {
      id: 'Plastic 59089',
      dataLabels: {
        format: `<div class="text-end">
  <h3>${'Plastic'}</h3>
  <p>Vehical Id : [59089]</p>
</div>`,
        useHTML: true,
        x: 50,
        y: 1,
      },
    },
  ]

  const plasticMaterialNode = [
    {
      id: '55',
      dataLabels: {
        format: `<h3>Vehicle Collection Job 55</h3>`,
        useHTML: true,
        x: 50,
        // y: 5,
      },
      offset: 10,
    },
    {
      id: '56',
      dataLabels: {
        format: `<h3>Vehicle Collection Job 56</h3>`,
        useHTML: true,
        x: 50,
        // y: 10,
      },
      offset: 10,
    },
    {
      id: '57',
      dataLabels: {
        format: `<h3>Vehicle Collection Job 57</h3>`,
        useHTML: true,
        x: 50,
        // y: 5,
      },
      offset: 10,
    },
    {
      id: '58',
      dataLabels: {
        format: `<h3>Vehicle Collection Job 58</h3>`,
        useHTML: true,
        x: 50,
        // y: 5,
      },
      offset: 10,
    },
    {
      id: '39',
      dataLabels: {
        format: `<h3>Disptach(Recycle) Request Job 39</h3>`,
        useHTML: true,
        x: 50,
        // y: 50,
      },
      offset: 10,
    },
    {
      id: '40',
      dataLabels: {
        format: `<h3>Disptach(Recycle) Request Job 40</h3>`,
        useHTML: true,
        x: 50,
        // y: 80,
      },
      offset: 10,
    },
    {
      id: '6',
      dataLabels: {
        format: `<h3>Sorting Job 6</h3>`,
        useHTML: true,
        x: 50,
        // y: 20,
      },
      offset: 10,
    },
    {
      id: '7',
      dataLabels: {
        format: `<h3>Sorting Job 7</h3>`,
        useHTML: true,
        x: 50,
        // y: 20,
      },
      offset: 10,
    },
    {
      id: '201',
      dataLabels: {
        format: `<h3>Grinding Job 201</h3>`,
        useHTML: true,
        x: 50,
        // y: 20,
      },
      offset: 10,
    },
    {
      id: '12',
      dataLabels: {
        format: `<h3>Pre-Compounding Pelletizing Job 12</h3>`,
        useHTML: true,
        x: 50,
        y: 130,
      },
      offset: 10,
    },
    {
      id: '41',
      dataLabels: {
        format: `<h3>Material Sales Material Producer Job 41</h3>`,
        useHTML: true,
        x: 50,
        y: 20,
      },
      offset: 10,
    },
    {
      id: '301',
      dataLabels: {
        format: `<h3>Compounding Pelletizing Job 301</h3>`,
        useHTML: true,
        x: 50,
        y: 120,
      },
      offset: 10,
    },
    {
      id: '460',
      dataLabels: {
        format: `<h3>Material Sales Part Producer Job 460</h3>`,
        useHTML: true,
        x: 50,
        // y: 20,
      },
      offset: 10,
    },
    {
      id: '102',
      dataLabels: {
        format: `<h3>Part Production (Moulding Job) 102</h3>`,
        useHTML: true,
        x: 50,
        y: 120,
      },
      offset: 10,
    },
    {
      id: '97',
      dataLabels: {
        format: `<h3>Part Sales Producer Job 97</h3>`,
        useHTML: true,
        x: 50,
        // y: 20,
      },
      offset: 10,
    },
    {
      id: '103',
      dataLabels: {
        format: `<h3>Vehicle Production 103</h3>`,
        useHTML: true,
        x: 50,
        y: 120,
      },
      offset: 10,
    },
  ]

  const otherMaterialData = [
    ['Scrap Vehicle 10034', 'Recycle Job 29890 ', 12],
    ['Scrap Vehicle 10101', 'Recycle Job 29891', 14],
    ['Scrap Vehicle 10108', 'Recycle Job 29892', 18],

    ['Recycle Job 29890', 'Heat 31098', 12],
    ['Recycle Job 29891', 'Heat 31098', 14],
    ['Recycle Job 29892', 'Heat 31099', 18],

    ['Heat 31098', 'Body:Part 40989', 8],
    ['Heat 31098', 'Engine:Part 40990', 8],
    ['Heat 31098', 'Chassis:Part 40991', 10],
    ['Heat 31099', 'Transmission:Part 40992', 18],

    ['Body:Part 40989', 'Steel 59089', 8],
    ['Engine:Part 40990', 'Steel 59089', 8],
    ['Chassis:Part 40991', 'Steel 59089', 10],
    ['Transmission:Part 40992', 'Steel 59089', 18],
    ['Bumper:Part 40993', 'Plastic 59089', 10],
  ]
  const plasticMaterialData = [
    ['55', '39', 1],
    ['56', '39', 1],
    ['57', '40', 1],
    ['58', '40', 1],

    ['39', '6', 2],
    ['40', '7', 2],

    ['6', '201', 2],
    ['7', '201', 2],

    ['201', '12', 4],

    ['12', '41', 4],

    ['41', '301', 4],

    ['301', '460', 4],

    ['460', '102', 4],

    ['102', '97', 4],

    ['97', '103', 4],
  ]

  const plasticData = {
    55: `<div class="text-start w-100">
      <h3>Vehicle Collection Job 55</h3>
      <p>Scrapping Facility Name: RVSF Noida</p>
      <p>Scrapping Facility Vehicle Number: 10042, 10052, 10062</p>
    </div>`,
    56: `<div class="text-start w-100">
      <h3>Vehicle Collection Job 56</h3>
      <p>Scrapping Facility Name: RVSF Noida</p>
      <p>Scrapping Facility Vehicle Number: 10072, 10082, 10092</p>
    </div>`,
    57: `<div class="text-start w-100">
      <h3>Vehicle Collection Job 57</h3>
      <p>Scrapping Facility Name: RVSF Noida</p>
      <p>Scrapping Facility Vehicle Number: 10043</p>
    </div>`,
    58: `<div class="text-start w-100">
      <h3>Vehicle Collection Job 58</h3>
      <p>Scrapping Facility Name: RVSF Noida</p>
      <p>Scrapping Facility Vehicle Number: 10053, 10063</p>
    </div>`,
    39: `<div class="text-start w-100">
      <h3>Dispatch (Recycle) Request Job ID: 39</h3>
      <p>Scrapping Facility Name: RVSF Noida</p>
      <p>Material Producer Name: Plastic Producer</p>
      <p>Invoice Number: 3188</p>
      <p>Bucket ID: 40993</p>
      <p>Bucket Name: Plastic</p>
      <p>Total Weight: 990 Kg</p>
      <p>Round: 1</p>
    </div>`,
    40: `<div class="text-start w-100">
      <h3>Dispatch (Recycle) Request Job ID: 40</h3>
      <p>Scrapping Facility Name: RVSF Noida</p>
      <p>Material Producer Name: Plastic Producer</p>
      <p>Invoice Number: 3190</p>
      <p>Bucket ID: 40993</p>
      <p>Bucket Name: Plastic</p>
      <p>Total Weight: 1000 Kg</p>
      <p>Round: 2</p>
    </div>`,
    6: `<div class="text-start w-100">
      <h3>Sorting Job ID: 6</h3>
      <p>Batch Number: B250117010</p>
      <p>Batch Weight: 950 Kgs</p>
      <p>Process Loss: 40 Kgs</p>
      <p>Polymer Type: PP Painted</p>
    </div>`,
    7: `<div class="text-start w-100">
      <h3>Sorting Job ID: 7</h3>
      <p>Batch Number: B250117011</p>
      <p>Batch Weight: 960 Kgs</p>
      <p>Process Loss: 40 Kgs</p>
      <p>Polymer Type: PP Painted</p>
    </div>`,
    201: `<div class="text-start w-100">
      <h3>Grinding Job ID: 201</h3>
      <p>Batch Number: JB02250117010</p>
      <p>Number of Jumbo Bags: 7</p>
      <p>Weight of each bag: 250 Kgs</p>
      <p>Quantity of Output produced: 1750 Kgs</p>
      <p>Process Loss: 160 Kgs</p>
      <p>Polymer Type: PP Painted</p>
    </div>`,
    12: `<div class="text-start w-100">
      <h3>Pre-Compounding Pelletizing Job ID: 12</h3>
      <p>Batch Number: C02250117010</p>
      <p>Number of Jumbo Bags: 67</p>
      <p>Weight of each bag: 25 Kgs</p>
      <p>Quantity of Output produced: 1675 Kgs</p>
      <p>Process Loss: 75 Kgs</p>
      <p>Polymer Type: PP01</p>
    </div>`,
    41: `<div class="text-start w-100">
      <h3>Material Sales Material Producer Job ID: 41</h3>
      <p>Seller: Plastic Producer</p>
      <p>Buyer: Plastic Compounding Company</p>
      <p>Batch Number: C02250117010</p>
      <p>Invoice Number: SAH2</p>
    </div>`,
    301: `<div class="text-start w-100">
      <h3>Compounding Pelletizing Job ID: 301</h3>
      <p>Added Virgin Input: 3908 Kgs</p>
      <p>Virgin Input Source: Raghav Polymers</p>
      <p>Batch Number: D02250117010</p>
      <p>Number of Jumbo Bags: 220</p>
      <p>Weight of each bag: 25 Kgs</p>
      <p>Quantity of Output produced: 5500 Kgs</p>
      <p>Process Loss: 83 Kgs</p>
      <p>Polymer Type: PP01</p>
    </div>`,
    460: `<div class="text-start w-100">
      <h3>Material Sales Part Producer Job ID: 460</h3>
      <p>Seller: Plastic Compounding Company</p>
      <p>Buyer: Part Producer</p>
      <p>Batch Number: D02250117010</p>
      <p>Invoice Number: SAH3</p>
      <p>Quantity Sold: 5500 Kgs</p>
    </div>`,
    102: `<div class="text-start w-100">
    <h3>Part Production (Moulding) Job ID: 102</h3>
    <p>Type of Product: Bumper</p>
    <p>Part ID: 3001, 3002...</p>
    <p>Part Batch ID: PB3</p>
    <p>Quantity of Output Produced: 50</p>
    <p>Weight of each Output unit: 50 Kgs</p>
    <p>Total Weight: 2500 Kgs</p>
  </div>`,
    97: `<div class="text-start w-100">
    <h3>Part Sales Producer Job ID: 97</h3>
    <p>Seller: Part Producer</p>
    <p>Buyer: Maruti Suzuki India Ltd</p>
    <p>Type of Product: Bumper</p>
    <p>Part ID: 3001, 3002...</p>
    <p>Part Batch ID: PB3</p>
    <p>Invoice Number: SAH4</p>
    <p>Quantity Sold: 50</p>
    <p>Weight of each Output unit: 50 Kgs</p>
    <p>Total Weight: 2500 Kgs</p>
  </div>`,
    103: `<div class="text-start w-100">
    <h3>Vehicle Production Job ID: 103</h3>
    <p>Model Name: Maruti Nexa</p>
    <p>Vehicle Category: 4W (Private)</p>
    <p>Vehicle ID: 12345678-12-DF-345</p>
    <p>DPP ID: 7p165e4c-40glk-528j</p>
    <p>Chassis No: MA3BNC22SLG24519</p>
    <p>Engine No: K15BN1122119</p>
    <p>Month/Year of Manufacture: 04/2024</p>
  </div>`,
  }

  const plasticTooTip = {
    useHTML: true,
    headerFormat: '',
    pointFormatter: function () {
      if (this.from) {
        return plasticData?.[this?.from]
      }
    },
    nodeFormatter: function () {
      if (this.id) {
        return plasticData?.[this?.id]
      }
    },
  }

  const otherToolTip = {
    headerFormat: null,
    pointFormat:
      '{point.fromNode.name} \u2192 {point.toNode.name}: {point.weight:.2f} ' +
      '',
    nodeFormat: '{point.name}: {point.sum:.2f} ',
  }

  const options = {
    title: {
      text: '',
    },
    subtitle: {
      text: '',
    },
    credits: false,
    accessibility: {
      point: {
        valueDescriptionFormat: `{index}. {point.from} to {point.to},  {point.weight}.`,
      },
    },
    tooltip: isEqual(materialType, 'bumper') ? plasticTooTip : otherToolTip,
    series: [
      {
        keys: ['from', 'to', 'weight'],

        nodes: isEqual(materialType, 'bumper')
          ? plasticMaterialNode
          : otherMaterialNode,

        data: isEqual(materialType, 'bumper')
          ? plasticMaterialData
          : otherMaterialData,
        type: 'sankey',
        name: 'Sankey demo series',
      },
    ],
  }
  return <HightChart {...{ options }} />
}

export default SankeyCharts
